import { v4 as uuidv4 } from 'uuid';

export function ProductSummaryList(props = {}, childrenComponents = [], blocks = []) {
	return {
		componentId: uuidv4(),
		componentName: 'ProductSummaryList',
		props: Object.assign(
			{
				category: '',
				specificationFilters: [],
				collection: '',
				orderBy: 'OrderByPriceDESC',
				hideUnavailableItems: true,
				maxItems: 8,
				skuFilter: 'ALL_AVAILABLE',
				installmentCriteria: 'MAX_WITHOUT_INTEREST',
				listName: '',
				preferredSKU: 'FIRST_AVAILABLE',
			},
			props,
		),
		blocks,
		childrenComponents,
	};
}
